import { capitalize } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AssistantIcon } from "../../Assets/svgs/AssistantIcon";
import { Loader } from "../../Common/Loader";
import { getContactGroupById } from "../../Redux/Slice/Contacts/Contact Group/GetContactGroupByIdSlice";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { deleteContactGroupMember } from "../../Redux/Slice/Contacts/Contact Group/DeleteGroupMemberSlice";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";

const ChatGroups = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [groupDetails, setGroupDetails] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    visible: false,
    selectedRow: null,
  });
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });
  const members = Array.isArray(groupDetails?.contacts)
    ? groupDetails?.contacts
    : [];

  const assistantName = location?.state?.assistantName ?? "";
  const allPaths = location.pathname.split("/");
  const groupId = allPaths[allPaths.length - 2];
  const assistantId = allPaths[allPaths.length - 1];

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const getContactDetails = async () => {
    setLoading(true);
    try {
      const result = await dispatch(getContactGroupById(groupId));
      if (
        getContactGroupById.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        const data = result.payload.data;
        setGroupDetails(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onDelete = async (selectedRow) => {
    setConfirmModal({
      visible: false,
      selectedRow: null,
    });
    setLoading(true);
    try {
      const result = await dispatch(
        deleteContactGroupMember({
          groupId: groupId,
          contactId: selectedRow?.id,
        })
      );
      if (
        deleteContactGroupMember.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        showSuccessMessage("Contact Deleted Successfully!",getContactDetails);
      } else {
        showErrorMessage(result?.payload?.error?.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getContactDetails();
  }, [groupId]);

  return (
    <div className="page__body">
      {loading ? <Loader /> : null}
      {errorModal.visible && <ErrorModel message={errorModal.message} />}
      {successModal.visible && <SuccessModel message={successModal.message} />}
      {confirmModal.visible ? (
        <ConfirmModel
          onAccept={() => onDelete(confirmModal.selectedRow)}
          onReject={() => {
            setConfirmModal({
              visible: false,
              selectedRow: null,
            });
          }}
          title="Delete Contact!"
          message="Are you sure you want to Delete the Contact?"
        />
      ) : (
        ""
      )}
      <div className="chatsWrap">
        <div className="chatsWrap__head">
          <div className="chatsWrap__head__profile">
            <div className="initials initials--bgBlue">
              {groupDetails?.avatar ? (
                <img src={groupDetails?.avatar} alt="" />
              ) : (
                String(groupDetails?.name)[0]
              )}
            </div>
            <div className="info">
              <h4 className="name">{groupDetails?.name}</h4>
              <p className="para">{members?.length} members</p>
            </div>
          </div>
          <div className="chatsWrap__head__action">
            <button className="btn p_0">
              <AssistantIcon />
              {assistantName}
            </button>
          </div>
        </div>
        <div className="chatsWrap__body chatsWrap__body--full">
          <div className="chatsSearchResult">
            <div className="chatsWrap__body__head">
              <h3 className="title">
                All Group Members{" "}
                <span className="count count--danger">{members?.length}</span>
              </h3>
            </div>
            <div className="assistantList">
              {members?.map((member) => (
                <div className="assistantList__item">
                  <div className="assistantList__card">
                    <div className="icon">
                      {member?.avatar ? (
                        <img src={member?.avatar} alt="" />
                      ) : (
                        capitalize(
                          String(`${member?.firstName} ${member?.lastName}`)[0]
                        )
                      )}
                    </div>
                    <div className="infoDetail">
                      <h2 className="title">
                        {capitalize(`${member?.firstName} ${member?.lastName}`)}
                      </h2>
                      {/* <p className="para">
                        Start to manage you chats with {assistantName}
                      </p> */}
                    </div>
                    <div className="btn__group">
                      <button
                        className="btn btn__primary btn__outlined"
                        onClick={() => {
                          navigate(
                            `/chat/individual/${member?.id}/${assistantId}`
                          );
                        }}
                      >
                        View Chat
                      </button>
                      <button
                        className="btn btn__danger btn__outlined"
                        onClick={() =>
                          setConfirmModal({
                            visible: true,
                            selectedRow: member,
                          })
                        }
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatGroups;
